import { ListFieldsKeys, ListFieldsRecordType, ListFieldsType } from "../../../api/config";
// import { GetItemsRequestProps } from "src/modules/modules.type";
import { GetFiltersType, PopulateFieldDescriptor } from "src/modules/modules.type";
import { getStrapiItemsRequest } from "./getStrapiItemsRequest";

export type FetchOptions<K extends ListFieldsKeys> = {
  listName: K;
  filters?: Partial<GetFiltersType<K>>;
  filtersType?: "or" | "and";
  viewFields?: Partial<Array<keyof ListFieldsType[K]>>;
  sortOrder?:
  | string
  | {
    name: string;
    desc?: boolean;
    asc?: boolean;
  }
  | {
    name: string;
    desc?: boolean;
    asc?: boolean;
  }[];
  nextPage?: number | null;
  rowLimit?: number;
  all?: boolean;
  anySite?: string;
  populateFields?: PopulateFieldDescriptor[];
  signal?: any;
  recursiveAll?: boolean;
  switchPopulate?: boolean;
  switchViewFields?: boolean;
  localFilters?: any
  otherParams?: any
  method?: string
  showPrivateCollections?: boolean
  skipHiddenLocationFilter?: boolean
  isLocalDate?: boolean
};

export const getItemsRequest = <K extends ListFieldsKeys>({
  listName,
  filters,
  viewFields,
  sortOrder,
  nextPage,
  rowLimit,
  filtersType = "and",
  recursiveAll,
  anySite,
  populateFields,
  signal,
  switchPopulate,
  switchViewFields,
  localFilters,
  otherParams,
  method,
  showPrivateCollections = true,
  skipHiddenLocationFilter,
  isLocalDate = false
}: FetchOptions<K>) => {
  const options = {
    listName,
    filters,
    viewFields,
    sortOrder,
    nextPage,
    rowLimit,
    filtersType,
    recursiveAll,
    anySite,
    populateFields,
    signal,
    switchPopulate,
    switchViewFields,
    localFilters,
    otherParams,
    method,
    showPrivateCollections,
    skipHiddenLocationFilter,
    isLocalDate
  };

  return getStrapiItemsRequest(options) as Promise<{
    items: ListFieldsRecordType[typeof listName][];
    listName: typeof listName;
    nextPage: any;
    count: number;
  }>;
};
